export default __webpack_public_path__ + "static/media/success.12ad79f1.svg";